module.exports = __webpack_public_path__ + "img/hakuna_xmas_bg02.3ebd8ec8.jpg";